import React, { memo } from 'react'
import { Card } from 'antd'
import { Link } from 'react-router-dom'
import { IDataByDayItem } from '../../model/selectors'
import HeaderWithTextTemplate from '../header-with-text-template/header-with-text-template'
import HeaderWithDateTemplate from '../header-with-date-template/header-with-date-template'
import { TaskIcon, CardWrapper } from './styles'

interface TaskDetailCardProps {
  task: IDataByDayItem
  compact?: boolean
}

export const TaskDetailCard: React.FC<TaskDetailCardProps> = memo(({ task, compact = false }) => {
  const getUrl = (card_type?: string) => {
    if (card_type === 'case') return 'order'
    if (card_type === 'claim_work') return 'claim-work'
    return card_type
  }

  return (
    <CardWrapper $compact={compact}>
      <Card size="small" hoverable>
        <HeaderWithTextTemplate
          title={
            <>
              <TaskIcon $stage={task.stage} /> Задача №{task.id}: {task.type}
            </>
          }
        />
        {Boolean(task?.brand) && <HeaderWithTextTemplate title={'Бренд:'} text={task?.brand} />}
        {Boolean(task?.order_attribute) && (
          <HeaderWithTextTemplate title={'Признак заказа:'} text={task?.order_attribute} />
        )}
        {Boolean(task?.production_number) && (
          <HeaderWithTextTemplate title={'Номер произ.заказа:'} text={task.production_number} />
        )}
        {Boolean(task?.name) && <HeaderWithTextTemplate title={'ФИО клиента:'} text={task.name} />}
        {Boolean(task?.address) && <HeaderWithTextTemplate title={'Адрес:'} text={task?.address} />}
        {Boolean(task?.responsible) && (
          <HeaderWithTextTemplate title={'Ответственные:'} text={task?.responsible?.join(', ')} />
        )}
        {Boolean(task?.task) && <HeaderWithTextTemplate title={'Комментарий:'} text={task?.task} />}
        <HeaderWithDateTemplate date={task.deadline} title={'Крайний срок:'} />
        <HeaderWithTextTemplate
          title={
            <Link to={`/${getUrl(task.card_type)}/${task.card_id}`}>
              Перейти в запись №{task.card_id}
            </Link>
          }
        />
      </Card>
    </CardWrapper>
  )
})

TaskDetailCard.displayName = 'TaskDetailCard'
